"use strict";

module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/valid-callable.js
// module id = 55
// module chunks = 0